import React from "react";
import PropTypes from "prop-types";
import { QuestionOption } from "./QuestionOption";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import {
  ColorBoxGroup,
  RenderTubeImage,
  TestTubeFeedback,
} from "@learningblocks/storybook-components";
import "./style.scss";

export function ColorSelectQuestionContent(props) {
  const renderQuestion = () => (
    <h5>
      <RichText className="colorSelectWidget_question" text={props.question} />
    </h5>
  );

  const onChangeColor = (optionIndex) => {
    return (params) => {
      props.onColorSelect({ ...params, optionIndex });
    };
  };

  const renderOption = (option, key) => (
    <div className="colorSelectWidget_options_item">
      <QuestionOption key={key} optionLabel={option.optionLabel}>
        <RenderTubeImage {...option.optionTube} />
        <ColorBoxGroup
          className="colorSelectOption_colorGroup"
          checkboxes={option.checkboxes}
          onChange={onChangeColor(key)}
        />
        <TestTubeFeedback {...option.feedback} />
      </QuestionOption>
    </div>
  );

  const renderOptions = () => (
    <div
      className="colorSelectWidget_options"
      aria-label="Four tubes of water containing the pH indicator Bromothymol blue. The solution in each of the tubes is green. Tube 1 is uncovered, and does not contain an Elodea plant. Tube 2 is covered, and also does not contain an Elodea plant. Tube 3 is uncovered, and contains an Elodea plant. Tube 4 is covered, and contains an Elodea plant."
    >
      {props.options.map(renderOption)}
    </div>
  );

  const renderContent = (type) => {
    switch (type) {
      case "question":
        return renderQuestion();
      case "options":
        return renderOptions();
      default:
        return null;
    }
  };

  return (
    <div className="colorSelectWidget">
      {props.contentItems.map(renderContent)}
    </div>
  );
}

ColorSelectQuestionContent.propTypes = {
  /**
   * List of content Items to display
   */
  contentItems: PropTypes.arrayOf(PropTypes.string),
  /**
   * Text to display as question
   */
  question: PropTypes.string,
  /**
   * List of options
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Label for option
       */
      optionLabel: PropTypes.string.isRequired,
      /**
       * Data needed to render optionTube
       */
      optionTube: PropTypes.shape({
        /**
         * Type of the tube Image
         */
        type: PropTypes.oneOf(["TUBE", "GLASS_TUBE"]).isRequired,
      }),
      /**
       * List of Checkboxes to display for option
       */
      checkboxes: PropTypes.arrayOf(PropTypes.object).isRequired,
      /**
       * data to show feedback
       */
      feedback: PropTypes.shape({
        /**
         * Boolean to set if feedback should be displayed
         */
        showFeedback: PropTypes.bool.isRequired,
        /**
         * Boolean to set if feedback should be correct/incorrect state
         */
        isCorrect: PropTypes.bool,
        /**
         * Message to display on feedback
         */
        message: PropTypes.string,
      }).isRequired,
    })
  ),
  /**
   *  funciton to invoke when a checkbox is selected
   */
  onColorSelect: PropTypes.func,
};

ColorSelectQuestionContent.defaultProps = {
  contentItems: ["question", "options"],
};
